(function () {
  function bindLandingCta() {
    var leadRoot = document.querySelector('[data-ktm-lead-form]');
    if (leadRoot) {
      leadRoot.id = 'ktm-lead-form-anchor';
    }

    document.querySelectorAll('[data-ktm-landing-cta]').forEach(function (link) {
      if (link.dataset.ktmLandingCtaInit === '1') {
        return;
      }
      link.dataset.ktmLandingCtaInit = '1';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var target =
          document.querySelector('[data-ktm-lead-form]') ||
          document.getElementById('ktm-lead-form-anchor');
        if (!target) {
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLandingCta);
  } else {
    bindLandingCta();
  }
})();
